import { Link } from "react-router-dom";
import { stripHtml } from "../../utils/richText";

export default function CategoryCard({ category, active = false }) {
 return (
  <Link
   to={`/products?category=${category.id}`}
   className={`group flex min-w-[210px] flex-col overflow-hidden rounded-xl border bg-white shadow-soft transition duration-300 hover:-translate-y-1 hover:shadow-lift sm:min-w-0 ${
    active ? "border-primary" : "border-line"
   }`}
  >
   <div className="relative aspect-[4/3] w-full overflow-hidden bg-slate-50">
    <img
     src={category.image}
     alt={stripHtml(category.name)}
     className="h-full w-full object-cover object-left transition duration-300 group-hover:scale-105"
     //  className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
    />
   </div>

   <div className="flex flex-1 flex-col px-3 pb-4 pt-3">
    <h3 className="line-clamp-2 text-[18px] font-medium leading-6 text-[#0f5f99] transition-colors group-hover:text-secondary">
     {stripHtml(category.name)}
    </h3>

    <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-600">
     {category.description ||
      "Premium quality EV components designed for reliable performance and long-lasting durability."}
    </p>
   </div>
  </Link>
 );
}
